import { numberMoney } from 'Data/format.js'

export function getValue(payment_plan) {
  let amount = payment_plan.charges.reduce(
    (acc, discount) => acc + discount.amount,
    0
  )
  return `(${payment_plan.charges.length}) - ${numberMoney(amount)}`
}
